export * from './parcel-shops-list.component';
